<div class="error-dialog">
    <mat-icon class="error-icon">error_outline</mat-icon>
    <h2>Error</h2>
    <p>{{ data.message }}</p>
    <button mat-button (click)="closeDialog()" class="close-btn">OK</button>
  </div>
  